<template>
  <div class="container">
    <h4 class="cardD">Cotización</h4>

    <h4 class="cardD">Resumen de Notificación</h4>

    <table class="table table-bordered table-hover table-fixed">
      <thead class="">
        <tr>
          <th class="check-col">Check</th>
          <th class="descripcion-col">Descripción</th>
          <th class="precio-col">Precio</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="">✓</td>
          <td class="">Costo por zona indicada</td>
          <td class="font-weight-bold precio-col-container">{{ formattedCostoZona }}</td>
        </tr>
      </tbody>
    </table>

    <h4 class="cardD mt-1" v-if="cantidad_adicionales_fisicas > 0">Solicitantes Adicionales</h4>
    <div v-if="cantidad_adicionales_fisicas > 0">
      <table class="table table-bordered table-hover table-fixed">
        <thead class="">
          <tr>
            <th class="check-col">Cantidad</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="">{{ cantidad_adicionales_fisicas }}</td>
            <td class="">Persona Física Adicional</td>
            <td class="font-weight-bold precio-col-container">{{ formattedPersonasAdicionales }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="" v-if="cantidad_adicionales_morales > 0">
      <table class="table table-bordered table-hover table-fixed">
        <thead class="">
          <tr>
            <th class="check-col">Cantidad</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="">{{ cantidad_adicionales_morales }}</td>
            <td class="">Persona Moral Adicional</td>
            <td class="font-weight-bold">{{ formattedPersonaMoralAdicional }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="" v-if="cantidad_adicionales_representantes > 0">
      <table class="table table-bordered table-hover table-fixed">
        <thead class="">
          <tr>
            <th class="check-col">Cantidad</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="">{{ cantidad_adicionales_representantes }}</td>
            <td class="">Representante Adicional</td>
            <td class="font-weight-bold precio-col-container">{{ formattedRepresentanteAdicional }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="subtotal_solicitantes > 0" class="mt-2">
      <div class="d-flex justify-content-around">
        <div>
          <p class="font-weight-bold">Subtotal</p>
        </div>
        <div>
          <p class="orange-text">{{ subtotal_solicitantes }}</p>
        </div>
      </div>
    </div>

    <h4 class="cardD mt-1" v-if="subtotal_documentos > 0">Documentos</h4>
    <div class="mt-2" v-if="cantidad_documentos_adicionales > 0">
      <table class="table table-bordered table-hover table-fixed">
        <thead class="">
          <tr>
            <th class="check-col">Cantidad</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="">{{ cantidad_documentos_adicionales }}</td>
            <td class="">Documentos Adicionales</td>
            <td class="font-weight-bold precio-col-container">{{ formattedDocumentosAdicionales }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="" v-if="notificacion.fad">
      <table class="table table-bordered table-hover table-fixed">
        <thead class="">
          <tr>
            <th class="check-col">Check</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="">✓</td>
            <td class="">Firma Autógrafa Digital</td>
            <td class="font-weight-bold precio-col-container">{{ formattedFad }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mt-2" v-if="paginas_extra > 0">
      <table class="table table-bordered table-hover table-fixed">
        <thead class="">
          <tr>
            <th class="check-col">Cantidad</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="">{{ paginas_extra }}</td>
            <td class="">Páginas Adicionales</td>
            <td class="font-weight-bold precio-col-container">{{ formattedPaginasExtra }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="" v-if="notificacion.contenido_digital">
      <table class="table table-bordered table-hover table-fixed">
        <thead class="">
          <tr>
            <th class="check-col">Check</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="">✓</td>
            <td class="">Contenido Digital</td>
            <td class="font-weight-bold precio-col-container">{{ formattedContenidoDigital }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- <h4 class="cardD">Agregar Extras</h4>

    <div class="row mt-4">
      <div class="col-md-12">
        <div style="display: flex; align-items: center">
          <b-form-checkbox v-model="notificacion.acta_express" disabled>
            Generación de acta y entregable en plazo de 2-4 días hábiles
          </b-form-checkbox>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <div style="display: flex; align-items: center">
          <b-form-checkbox v-model="notificacion.envio_domicilio" disabled>Envío a domicilio del entregable</b-form-checkbox>
        </div>
      </div>
    </div> -->

    <hr v-if="subtotal_extras > 0" />

    <h4 class="cardD" v-if="subtotal_extras > 0">Extras</h4>

    <div class="" v-if="notificacion.acta_express">
      <table class="table table-bordered table-hover">
        <thead class="">
          <tr>
            <th class="check-col">Check</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td scope="row" class="">✓</td>
            <td class="">Generación de acta y entregable en plazo de 2-4 días hábiles</td>
            <td class="font-weight-bold precio-col-container">{{ formattedActaExpress }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="" v-if="notificacion.envio_domicilio">
      <table class="table table-bordered table-hover">
        <thead class="">
          <tr>
            <th class="check-col">Check</th>
            <th class="descripcion-col">Descripción</th>
            <th calss="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td scope="row" class="">✓</td>
            <td class="">Envío a domicilio del entregables</td>
            <td class="font-weight-bold precio-col-container">$500.00</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h4 class="cardD mt-1" v-if="notificacion.envio_domicilio">Descuentos</h4>
    <div class="" v-if="notificacion.envio_domicilio">
      <table class="table table-bordered table-hover">
        <thead class="">
          <tr>
            <th class="check-col">Check</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-col">Descuento</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="">✓</td>
            <td class="">Envío a domicilio del entregable</td>
            <td class="font-weight-bold precio-col-container">- $500.00</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h4 class="cardD mt-1">Cupones</h4>
    <div class="mt-1" v-if="cuponAplicado">
      <div class="container">
        <div class="row">
          <table class="table table-bordered table-hover">
            <thead class="">
              <tr>
                <th class="check-col">Check</th>
                <th class="descripcion-col">Descripción</th>
                <th class="precio-col">Descuento</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="">✓</td>
                <td class="">Cupón: {{ nombreCuponDescuento }}</td>
                <td class="font-weight-bold precio-col-container">({{ cantidadDescuentoCupon }}) {{ formattedValorCupon }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <h4 class="cardD mt-3 font-weight-bold">{{ textoTotalAPagar }}</h4>
      <div class="mt-2">
        <div class="font-weight-bold total">
          <div>
            <p class="orange-text">{{ formattedTotal }}</p>
          </div>
        </div>
      </div>
    </div>

    <h4 class="cardD mt-1">Información del pago</h4>
    <p class="mt-3">Fecha de pago: {{ fechaPago }}</p>

    <hr />

    <div class="row mt-4" v-for="clausula in clausulasConfirmacion" :key="clausula.id" hidden>
      <div class="col-md-12 d-flex">
        <div style="display: flex">
          <b-form-checkbox
            :id="'checkbox-validacionDatos-' + clausula.id"
            class="orange"
            v-model="clausula.confirmado"
            @change="clausulaConfirmacionHandler(clausula.id, $event)"
            disabled
          >
            {{ clausula.contenido }}
          </b-form-checkbox>
        </div>
      </div>
    </div>

    <div class="mt-4 d-flex justify-content-end">
      <div class="row">
        <div class="col-12">
          <b-button type="submit" class="orange-btn" size="m">Continuar</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency } from "@/utils/number-utils";
import {
  CatGastosApi,
  DocumentosXServiciosApi,
  DocumentosApi,
  NotificadosApi,
  FuncionesApi,
  DomiciliosApi,
  CotizacionesApi,
} from "@/api";

export default {
  name: "ValidaCotizacion",

  props: {
    notificacion: { type: Object },
    clausulasConfirmacion: {
      type: Array,
      default: () => [],
    },
  },

  created() {
    this.loading = true;

    this.notificacionId = this.$route.params.id;

    this.getGastos()
      .then(() => this.getDomicilioNotificacion())
      // .then(() => this.calculaSolicitantes())
      // .then(() => this.calculaSubtotalSolicitantes())
      .then(() => this.calculaDocumentos())
      .then(() => this.calculaSubtotalDocumentos())
      .then(() => this.calculaTotal())
      .then(() => this.recalculaExtras())
      .then(() => this.getCotizacion())
      .then(() => (this.costo_total = this.notificacion.costo_total))
      .catch((error) => {
        console.log(error);
        this.showErrorToast("No se pudieron obtener los totales. Intente más tarde.");
      })
      .finally(() => {
        this.loading = false;
      });

    this.costoTotalAntesCupon = this.notificacion.costo_total_antes_descuentos;
  },

  data() {
    return {
      loading: false,

      notificacionId: null,
      costo_zona: null,

      busyBtnAplicaCupon: false,

      // Costos en BD
      cat_gastos: null,
      precio_acta: 0,
      precio_adicional_fisica: 0,
      precio_adicional_moral: 0,
      precio_adicional_representante: 0,
      precio_fad: 0,
      precio_pagina_adicional: 0,
      precio_contenido_digital: 0,
      precio_documento_adicional: 0,
      // Costos pre-calculados
      precio_zona: 0,

      // Cantidades
      cantidad_adicionales_fisicas: 0,
      cantidad_adicionales_morales: 0,
      cantidad_adicionales_representantes: 0,
      cantidad_documentos_adicionales: 0,
      paginas_totales: 0,
      paginas_extra: 0,

      // Costos totales = Cantidad * Precio
      precio_total_adicional_fisica: 0,
      precio_total_adicional_moral: 0,
      precio_total_adicional_representante: 0,
      precio_total_documentos_adicionales: 0,
      precio_total_paginas_extra: 0,

      // Subtotales
      subtotal_zona: 0,
      subtotal_solicitantes: 0,
      subtotal_documentos: 0,
      subtotal_extras: 0,

      // Casillas de validacion
      validacionDatos: false,
      validacionTerminos: false,
      validacionPaginas: false,
      validacionMercantil: false,
      validacionInfoBase: false,

      cuponAplicado: false,
      nombreCuponDescuento: "",
      costoTotalAntesCupon: 0,
      cantidadDescuentoCupon: "",
      cantidadDescontadaCupon: 0,

      costo_total: null,
      statusPagado: false,
      fechaPago: "Sin pagar",
    };
  },

  computed: {
    formattedCostoZona() {
      return formatCurrency(this.costo_zona);
    },
    formattedPersonasAdicionales() {
      return formatCurrency(this.precio_adicional_fisica);
    },
    formattedPersonaMoralAdicional() {
      return formatCurrency(this.precio_total_adicional_moral);
    },
    formattedRepresentanteAdicional() {
      return formatCurrency(this.precio_total_adicional_representante);
    },
    formattedDocumentosAdicionales() {
      return formatCurrency(this.precio_total_documentos_adicionales);
    },
    formattedFad() {
      return formatCurrency(this.precio_fad);
    },
    formattedPaginasExtra() {
      return formatCurrency(this.precio_total_paginas_extra);
    },
    formattedContenidoDigital() {
      return formatCurrency(this.precio_contenido_digital);
    },
    formattedSubtotalDocumentos() {
      return formatCurrency(this.subtotal_documentos);
    },
    // TODO: Revisar porque no funciona
    formattedBeforeDiscount() {
      return formatCurrency(this.notificacion.costo_total_antes_descuentos);
    },
    formattedActaExpress() {
      return formatCurrency(this.precio_acta);
    },
    formattedSubtotalExtras() {
      return formatCurrency(this.subtotal_extras);
    },
    formattedTotal() {
      return formatCurrency(this.costo_total);
    },
    textoTotalAPagar() {
      let texto = "Total";
      if ((this.notificacion.acta_express || this.notificacion.envio_domicilio) && this.cuponAplicado) {
        texto += " con Extras y descuentos";
      } else if (!this.notificacion.acta_express && !this.notificacion.envio_domicilio && this.cuponAplicado) {
        texto += " con descuento";
      } else if (this.notificacion.acta_express || this.notificacion.envio_domicilio) {
        texto += " con Extras";
      }
      return texto;
    },
    totalAPagarSinDescuento() {
      return formatCurrency(this.notificacion.costo_total + this.subtotal_extras);
    },
    formattedValorCupon() {
      return formatCurrency(this.cantidadDescontadaCupon * -1);
    },
  },

  methods: {
    clausulaConfirmacionHandler(clausulaId, value) {
      this.$emit("clausulaConfirmacionChanged", clausulaId, value);

      switch (clausulaId) {
        case 2:
          this.validacionDatos = value;
          break;
        case 3:
          this.validacionPaginas = value;
          break;
        case 4:
          this.validacionTerminos = value;
          break;
        case 5:
          this.validacionMercantil = value;
          break;
        case 6:
          this.validacionInfoBase = value;
          break;
      }
    },

    showErrorToast(msg) {
      this.$toast.error(msg, {
        timeout: 4000, //false,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    async getCotizacion() {
      const cotizacion = await CotizacionesApi.detail(this.notificacion.id_cotizaciones);

      this.statusPagado = cotizacion.pagado;
      if (this.statusPagado) {
        this.fechaPago = cotizacion.fecha_pago.substring(0, 10);
      } else {
        this.fechaPago = "Sin pagar";
      }

      if (cotizacion.cupon_info) {
        let precio_total = this.notificacion.costo_total;

        this.cuponAplicado = true;
        this.nombreCuponDescuento = cotizacion.cupon_info.nombre;

        if (cotizacion.cupon_info.tipo === "Porcentaje") {
          let descuentoDecimal = cotizacion.cupon_info.descuento;

          if (cotizacion.descuento > 1) {
            descuentoDecimal = cotizacion.cupon_info.descuento / 100;
          }

          precio_total = this.notificacion.costo_total * (1 - descuentoDecimal);
          this.cantidadDescuentoCupon = "% " + descuentoDecimal * 100;
          this.cantidadDescontadaCupon = this.notificacion.costo_total * descuentoDecimal;
        } else if (cotizacion.cupon_info.tipo === "Monto") {
          precio_total = this.notificacion.costo_total - cotizacion.cupon_info.descuento;
          this.cantidadDescontadaCupon = cotizacion.cupon_info.descuento;
        }

        this.notificacion.costo_total = precio_total;
      }
    },

    async getDomicilioNotificacion() {
      const { value } = await NotificadosApi.list({
        id_notificaciones: this.notificacionId,
      });
      const domicilio = await DomiciliosApi.detail(value[0].id_domicilios);
      const mapResult = await FuncionesApi.mapIntersect({
        lat: domicilio.lat,
        lng: domicilio.lng,
      });

      this.costo_zona = mapResult.costo;
      this.subtotal_zona = this.costo_zona;
    },

    async getGastos() {
      const { value } = await CatGastosApi.filtraProcesos({
        page: 0,
        registersPerPage: 0,
        cat_servicios_id: "2",
      });

      this.cat_gastos = value;

      for (const gasto in this.cat_gastos) {
        if (this.cat_gastos[gasto]["clave"] === "acta_express") {
          this.precio_acta = this.cat_gastos[gasto]["costo"];
        }
        if (this.cat_gastos[gasto]["clave"] === "adicional_persona_fisica") {
          this.precio_adicional_fisica = this.cat_gastos[gasto]["costo"];
        }
        if (this.cat_gastos[gasto]["clave"] === "adicional_persona_moral") {
          this.precio_adicional_moral = this.cat_gastos[gasto]["costo"];
        }
        if (this.cat_gastos[gasto]["clave"] === "adicional_representante") {
          this.precio_adicional_representante = this.cat_gastos[gasto]["costo"];
        }
        if (this.cat_gastos[gasto]["clave"] === "pagina_adicional") {
          this.precio_pagina_adicional = this.cat_gastos[gasto]["costo"];
        }
        if (this.cat_gastos[gasto]["clave"] === "contenido_digital") {
          this.precio_contenido_digital = this.cat_gastos[gasto]["costo"];
        }
        if (this.cat_gastos[gasto]["clave"] === "fad_documento_principal") {
          this.precio_fad = this.cat_gastos[gasto]["costo"];
        }
        if (this.cat_gastos[gasto]["clave"] === "documento_adicional") {
          this.precio_documento_adicional = this.cat_gastos[gasto]["costo"];
        }
      }
    },

    async calculaSolicitantes() {
      return;
      // // Identifica tipo de persona. Ignora solicitante principal
      // this.notificacion.solicitantes.forEach(element => {
      //   if (element.principal) {
      //     return;
      //   }
      //   if (element.persona === 'Moral') {
      //     this.cantidad_adicionales_morales += 1;
      //   }
      //   if (element.persona === 'Física') {
      //     if (element.representada) {
      //       this.cantidad_adicionales_representantes += 1;
      //     } else {
      //       this.cantidad_adicionales_fisicas += 1;
      //     }
      //   }
      // });
      // // Se reducen los representantes incluidos (2)
      // this.cantidad_adicionales_representantes = Math.max(this.cantidad_adicionales_representantes - 2, 0);
      // return;
    },

    async calculaSubtotalSolicitantes() {
      this.precio_total_adicional_fisica = this.precio_adicional_fisica * this.cantidad_adicionales_fisicas;
      this.precio_total_adicional_moral = this.precio_adicional_moral * this.cantidad_adicionales_morales;
      this.precio_total_adicional_representante = this.precio_adicional_representante * this.cantidad_adicionales_representantes;
      this.subtotal_solicitantes =
        this.precio_total_adicional_fisica + this.precio_total_adicional_moral + this.precio_total_adicional_representante;
      return;
    },

    async calculaDocumentos() {
      const { value } = await DocumentosXServiciosApi.list({
        cat_servicios_id: 2,
        id_proceso: this.notificacionId,
      });

      let promises = [];

      for (const d of value) {
        promises.push(DocumentosApi.detail(d.documentos_id));
      }

      let arr = await Promise.all(promises);

      // Se filtran solo documentos a notificar (no anexos)
      arr = arr.filter((d) => [30, 31, 32, 33, 34, 35].includes(Number(d.cat_documentos_id)));

      if (arr.length == 0) {
        return;
      }

      // Calcula los documentos principales eliminando 1 incluido
      this.cantidad_documentos_adicionales = arr.length - 1;

      // Cantidad de paginas totales
      this.paginas_totales = arr.reduce((pt, d) => d.paginas + pt, 0);
      this.paginas_extra = Math.max(this.paginas_totales - 50, 0);
    },

    async calculaSubtotalDocumentos() {
      this.precio_total_documentos_adicionales = this.precio_documento_adicional * this.cantidad_documentos_adicionales;
      this.precio_total_paginas_extra = this.paginas_extra * this.precio_pagina_adicional;
      this.subtotal_documentos = this.precio_total_documentos_adicionales + this.precio_total_paginas_extra;

      if (this.notificacion.fad) {
        this.subtotal_documentos = this.subtotal_documentos + this.precio_fad;
      }

      if (this.notificacion.contenido_digital) {
        this.subtotal_documentos = this.subtotal_documentos + this.precio_contenido_digital;
      }
    },

    calculaTotal() {
      this.notificacion.costo_total_antes_descuentos = this.subtotal_zona + this.subtotal_solicitantes + this.subtotal_documentos;
      this.notificacion.costo_total = this.notificacion.costo_total_antes_descuentos;
    },

    recalculaExtras() {
      this.loading = true;
      this.subtotal_extras = 0;
      this.agregaActaExpress()
        .then(() => this.agregaEnvioDomicilio())
        .then(() => this.calculaTotalPostDescuento())
        .catch((error) => {
          console.log(error);
          this.showErrorToast("No se pudieron obtener los totales. Intente más tarde.");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    agregaActaExpress() {
      return new Promise((resolve, reject) => {
        try {
          if (this.notificacion.acta_express) {
            this.subtotal_extras = this.precio_acta;
          }
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },

    agregaEnvioDomicilio() {
      return new Promise((resolve, reject) => {
        try {
          if (this.notificacion.envio_domicilio) {
            this.subtotal_extras += 500;
          }
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },

    calculaTotalPostDescuento() {
      return new Promise((resolve, reject) => {
        try {
          this.notificacion.costo_total = this.notificacion.costo_total_antes_descuentos;
          if (this.subtotal_extras > 0) {
            this.notificacion.costo_total += this.subtotal_extras;
          }
          if (this.notificacion.envio_domicilio) {
            this.notificacion.costo_total -= 500;
          }
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
</script>

<style scoped>
.table-fixed {
  table-layout: fixed;
  width: 100%;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 8px;
  text-align: left;
}

.check-col {
  width: 10%;
  /* Ancho ajustado para la columna Check */
}

.descripcion-col {
  width: 70%;
  /* Ajusta este valor según sea necesario */
}

.precio-col {
  width: 20%;
  /* Ajusta este valor según sea necesario */
}

.precio-col-container {
  display: flex;
  justify-content: flex-end;
}

.total {
  font-weight: bold;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}
</style>
